import React,{useState} from 'react';
import logo from './logo.svg';
import './App.css';
import Image from "./asset/profile.jpeg";
import SkillyBrowser from "./asset/skillybrowser.png";
import SapphireMeet from "./asset/sapphiremeet.png";
import Algotarian from "./asset/Algotarian-Logo.png";
import AboutMe from "./asset/aboutme.jpeg";
import Insta from "./asset/insta.jpg";
import LinkedIn from "./asset/LinkedIn.png";
import Github from "./asset/github.png";
import { pushData } from "./service/pushData";

function App() {
  const [name,setName]=useState("");
  const [email,setEmail]=useState("");
  const [message,setMessage]=useState("");
  const [sent,setSent]=useState(false);
  const [sending,setSending]=useState(false);
  return (
    <div>
       <div className="fx sha"></div>
     <div className='project-block'>
       <button className="buttons" onClick={()=>{
         window.location.href="#about_section";
       }}>About Me</button>
       <img src={Image} height="600" className='cls'></img>
       <button className='buttons' onClick={(e)=>{
         window.location.href="#contact_section";
       }}>Contact Me</button>
     </div>
     <section  id="project_section" className="project-section">
       <div className="section">
       <div className="section-block">
       PROJECTS
     </div>
       </div>
     
     <div className='project-block'>
       <div className="project">
        <div className="project-title">
          Skilly Browser
        </div>
        <img src={SkillyBrowser} height="170" >
        </img>
        <button className="project-button" onClick={(e)=>{
          window.location.href="https://play.google.com/store/apps/details?id=com.skillybaba.skillybrowser&hl=en_IN&gl=US";
        }}>Visit</button>
       </div>
       <div className="project">
       <div className="project-title">
          Sapphire Meet
        </div>
        <img src={SapphireMeet} height="200" >
        </img>
        <button className="project-button" onClick={(e)=>{
          window.location.href="https://play.google.com/store/apps/details?id=com.sapphiremeet.sapphiremeet";
        }}>Visit</button>
       </div>
       <div className="project">
       <div className="project-title">
          Algo Bucket
        </div>
        <img src={Algotarian} height="200" >
        </img>
        <button className="project-button" onClick={(e)=>{
          window.location.href="https://algobucket.web.app";
        }}>Visit</button>
       </div>
     </div>
     </section>
     <section  id="about_section" className="project-section">
       <div className="section">
       <div className="section-block">
      ABOUT ME
     </div>
       </div>
       <div className="aboutme">
         <div>
           <img src={AboutMe}  className="aboutme-image"></img>
         </div>
         <div className="aboutme-text">
           <p className="aboutme-text-inside">
           Name - Kanishk Dixit
           </p>
          <p className="aboutme-text-inside">
          Age - {Math.floor(((new Date().getTime()-new Date(1999,7,4).getTime())/ 1000)/(60 * 60 * 24*365.25))}
          </p>
           <p className="aboutme-text-inside">
           Profession - Software Engineer 
           </p>
          <p className="aboutme-text-inside">
          Current Company - Zest Money
          </p>
           <p className="aboutme-text-inside">
           Current Designation - SDE 1
           </p>
           <p className="aboutme-text-inside">
           Skills - React React-Native Flutter Django Spring-Boot Angular Firebase Mysql Docker
           </p>
          
         </div>
       </div>
     
     </section>
     <section  id="contact_section" className="project-section">
       {sent?<div className='noti'>
         Message Sent
       </div>: sending?<div className='noti'>sending.....</div>:<></>}
       <div className="section">
       <div className="section-block">
      CONTACT ME
     </div>
     
       </div>
       <div className='contact-inputs'>
         <div className='inputs'>
         <input type="text" className="input-field" placeholder='Name' onChange={(e)=>{
           setName(e.target.value);
         }}/>
         <input type="text" className="input-field" placeholder='Email' onChange={(e)=>{
           setEmail(e.target.value);
         }}/>
         </div>
        <div className='inputs'>
        <input type="text" className="input-field input-bottom" placeholder='Message' onChange={(e)=>{
          setMessage(e.target.value);
        }}/>
        </div>
        <div className="inputs">
          <button className='input-button' disabled={sending}  onClick={async (e)=>{
            setSending(true);
            await pushData(
              {name:name,email:email,message:message}
            );
            setSending(false);
            setSent(true);
            
          }}>
            Send 
          </button>
        </div>
       </div>
     </section>
     <section  id="footer_section" className="footer-section">
      
      <button className='foot-button' onClick={(e)=>{
        window.location.href="http://instagram.com/mr.kanishk_d?utm_source=qr";
      }}>
        <img src={Insta} alt="" height={30} />
      </button>
      <button className='foot-button' onClick={(e)=>{
        window.location.href="https://www.linkedin.com/in/kanishk-dixit/";
      }}> <img src={LinkedIn} alt="" height={30} /></button>
      <button className='foot-button' onClick={(e)=>{
        window.location.href="https://github.com/kanzd";
      }}> <img src={Github} alt="" height={40} /></button>
     </section>
    </div>
  );
}

export default App;
